
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/superchain-migration",
      function () {
        return require("private-next-pages/superchain-migration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/superchain-migration"])
      });
    }
  